import { NavLink, Route, Routes } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import { useSession } from '@/lib/session';
import Overview from './tabs/Overview';
import FleetMap from './tabs/FleetMap';
import KeyWells from './tabs/KeyWells';
import Regions from './tabs/Regions';
import RigFleet from './tabs/RigFleet';
import Companies from './tabs/Companies';
import Sources from './tabs/Sources';
import Debug from './tabs/Debug';
import DataApi from './tabs/DataApi';

// World Wide Drilling — the offshore-drilling market module, rendered inside the portal
// shell at /wwd (same in-shell tab-nav pattern as HmhWatchApp). Phase B: data flows live
// from the WWD Api through the portal BFF reverse-proxy (lib/api -> /api/wwd/**). Debug is
// admin-only, exactly like HmhWatchApp's Usage/Debug tabs.
const baseTabs = [
  { to: '/wwd', label: 'Overview', end: true },
  { to: '/wwd/map', label: 'Map', end: false },
  { to: '/wwd/wells', label: 'Key Wells', end: false },
  { to: '/wwd/regions', label: 'Regions', end: false },
  { to: '/wwd/rigs', label: 'Rig Fleet', end: false },
  { to: '/wwd/companies', label: 'Companies', end: false },
  { to: '/wwd/sources', label: 'Sources', end: false },
];

export default function WwdApp() {
  const { data: session } = useSession();
  const isAdmin = !!session?.isAdmin;
  // Data API tab: admins AND the scoped "dataapi" login; Debug stays admin-only.
  const canDataApi = isAdmin || !!session?.isDataApi;

  const tabs = [
    ...baseTabs,
    ...(canDataApi ? [{ to: '/wwd/data-api', label: 'Data API', end: false }] : []),
    ...(isAdmin ? [{ to: '/wwd/debug', label: 'Debug', end: false }] : []),
  ];

  return (
    <div>
      <nav className="mb-6 flex flex-wrap gap-1 border-b border-border" aria-label="World Wide Drilling">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              'px-3 py-2 text-sm font-(family-name:--font-ui) border-b-2 -mb-px transition-colors ' +
              (isActive ? 'border-accent text-text' : 'border-transparent text-muted hover:text-text')
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Routes>
        <Route index element={<Overview />} />
        {/* Azure Maps canvas with Wells + Rigs tabs (replaced the hand-drawn canvas map). */}
        <Route path="map" element={<FleetMap />} />
        <Route path="wells" element={<KeyWells />} />
        <Route path="regions" element={<Regions />} />
        {/* Both render RigFleet — the :slug variant opens the spec modal over the list. */}
        <Route path="rigs" element={<RigFleet />} />
        <Route path="rigs/:slug" element={<RigFleet />} />
        <Route path="companies" element={<Companies />} />
        <Route path="sources" element={<Sources />} />
        <Route path="data-api" element={<DataApi />} />
        <Route path="debug" element={<Debug />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
